import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    persongidList: []
};

const getters = {
    getPersongid: state => state.persongidList
};

const actions = {
    getPersongid({commit}) {
        axiosGet(`crm/persons?alltypegid`).then(({data}) => {
            commit('PERSONGID_INFO', data)
        }).catch((error) => console.log(error));
    },
};

const mutations = {
    PERSONGID_INFO(state, data) {
        state.persongidList = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
